import { render } from "./StatsFilterOnView.vue?vue&type=template&id=50e99e8c&scoped=true"
import script from "./StatsFilterOnView.vue?vue&type=script&lang=ts"
export * from "./StatsFilterOnView.vue?vue&type=script&lang=ts"

import "./StatsFilterOnView.vue?vue&type=style&index=0&id=50e99e8c&lang=scss&scoped=true"
import "./StatsFilterOnView.vue?vue&type=style&index=1&id=50e99e8c&lang=scss"
script.render = render
script.__scopeId = "data-v-50e99e8c"

export default script